export enum ScreenTypeEnum {
    ShowRoutes = 1,
    ShowDirection = 2,
    showStopListLoader = 3,
    showStartStopList = 4,
    showEndStopList = 5,
    showTimeEntry = 6
}